export default "__VITE_ASSET__BhS99vJ2__"